var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"my-2"},[_vm._v("Products")]),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.products),function(product){return _c('div',{key:product.id,staticClass:"col-sm-6 col-md-4 p-2"},[_c('single-product',{attrs:{"product":product}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee8837d0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = 351
// module chunks = 0